import React, {Fragment, useEffect, useState} from "react";

// reactstrap components
import {Button, Card, CardFooter, CardHeader, Col, Container, Row, Table,} from "reactstrap";
// layout for this page
// core components
import {useHistory} from "react-router";
import {telWithCommas} from "../../../utils";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import PaginationWrapper from "../components/pagination";
import useHistoryState from "../../../common/useHistoryState";
import moment from "moment";
import companyStoreService from "./service/companyStore.service";
import companyService from "../company/service/company.service";
import api from "../../../config/api.routes";
import axios from "axios";
import authHeader from "../../../services/auth-header";
import shopService from "../shop/shop.service";

function CompanyStoreList() {
  const history = useHistory();
  const [pageActive, setPageActive] = useHistoryState(1, 'pageActive');
  const [pageCount, setPageCount] = useHistoryState(1, 'pageCount');
  const [data, setData] = useHistoryState([], 'data');
  const [companyList, setCompanyList] = useHistoryState([], 'companyList');
  const [category, setCategory] = useHistoryState('전체', 'category');
  const [startDate, setStartDate] = useHistoryState(moment().format('YYYY-MM-01'), 'startDate');
  const [endDate, setEndDate] = useHistoryState(moment().format('YYYY-MM-DD'), 'endDate');
  const [searchCurrent, setSearchCurrent] = useHistoryState(false, 'searchCurrent');
  const [search, setSearch] = useHistoryState('', 'search');
  const [checkList, setCheckList] = useState([]);

  const render = async () => {
    const res = await companyStoreService.list({ page: pageActive, companyId: checkList[0], category: '기업가맹점' });
    if (res.code === 200) {
      console.log(res);
      setPageCount(res.storeList.rows.length);
      setData(res.storeList.rows);
    }
  };

  useEffect(() => {
    render();
  }, [ pageActive, checkList ]);

  const companyRender = async () => {
    const res = await companyService.list({});
    if (res.code === 200) {
      console.log(res);
      setCompanyList(res.list);
    }
  };

  useEffect(() => {
    companyRender();
  }, [ ]);

  const statusChange = async (id, check) => {
    await companyStoreService.update(id, {check});
    render();
  }

  const isCheck = (value, type, setType) => {
    const index = type.indexOf(value); // value 값의 위치를 찾음.
    if (index > -1) { //  값이 있는 경우, -1은 값이없음.
      setType([
        ...type.filter(v => v !== value)
      ]);
    } else {
      setType([
        value
      ]);
    }
  };
  console.log(checkList)

  const remove = async (id) => {
    if (window.confirm('삭제하시겠습니까?')) {
      let res = await companyStoreService.remove(id);
      console.log(res);
      if (res.code === 200) {
        render();
        alert('삭제되었습니다.')
      }
    }
  }

  return (
    <>
      <SimpleHeader name="Tables" parentName="Tables" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0">
                <Row>
                  {companyList.map((v, i) => {
                    return <Col md="auto" key={i}>
                      <div className="custom-control custom-checkbox mb-3">
                        <input
                            className="custom-control-input"
                            id={"customCheck" + i}
                            type="checkbox"
                            value={v.name}
                            onClick={() => {
                              isCheck(v.id, checkList, setCheckList)
                            }}
                            checked={checkList.indexOf(v.id) > -1}
                            readOnly
                        />
                        <label
                            className="custom-control-label"
                            htmlFor={"customCheck" + i}
                        >
                          {v.name}
                        </label>
                      </div>
                    </Col>
                  })}
                </Row>
                <Row>
                  <Col xs="6">
                    <h3 className="mt-2">
                      기업 가맹점 관리
                    </h3>
                  </Col>
                  <Col className="text-right" xs="6">
                    <Button
                        className="btn-round btn-icon"
                        color="default"
                        onClick={(e) => history.push('/admin/company/storeForm')}
                    >
                      <span className="btn-inner--text">등록하기</span>
                    </Button>
                  </Col>
                </Row>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive striped>
                <thead className="thead-light">
                <tr>
                  <th className="text-center">상점명</th>
                  <th className="text-center">주소</th>
                  <th className="text-center">전화번호</th>
                  <th className="text-center">담당자 전화번호</th>
                  <th className="text-center">상점 구분</th>
                  <th className="text-center">등록일</th>
                  <th className="text-center">활성화</th>
                  <th className="text-center">관리</th>
                </tr>
                </thead>
                <tbody>
                {data?.map((item, i) => {
                  return [
                    <Fragment key={i}>
                      <tr>
                        <td className="text-center">
                          {item.name}
                        </td>
                        <td className="text-center">
                          {item.address}
                        </td>
                        <td className="text-center">
                          {telWithCommas(item.tel)}
                        </td>
                        <td className="text-center">
                          {telWithCommas(item.managerTel)}
                        </td>
                        <td className="text-center">
                          {item.category}
                        </td>
                        <td className="text-center">
                          {item.createdAt}
                        </td>
                        <td className="text-center">
                          <label className="custom-toggle custom-toggle-success center">
                            <input
                                checked={item.isShareBanner}
                                type="checkbox"
                                onChange={(e) => statusChange(item.id, !item.isShareBanner)}
                            />
                            <span
                                className="custom-toggle-slider rounded-circle"
                                data-label-off="No"
                                data-label-on="Yes"
                            />
                          </label>
                        </td>
                        <td className="text-center">
                          <Button
                              className="btn-outline-danger"
                              onClick={() => remove(item.id)}
                              size="sm"
                          >
                            <span className="btn-inner--text">삭제</span>
                          </Button>
                          <Button
                              className="btn-outline-default"
                              onClick={(e) => history.push('/admin/company/storeDetail/' + item.id)}
                              size="sm"
                          >
                            <span className="btn-inner--text">상세</span>
                          </Button>
                        </td>
                      </tr>
                    </Fragment>
                  ];
                })}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <PaginationWrapper
                  isActive={pageActive}
                  pageNumber={pageCount}
                  callback={(page) => setPageActive(page)}
                  itemPerPage={10}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default CompanyStoreList;
